import { render, staticRenderFns } from "./SurveyQuestionList.vue?vue&type=template&id=0204d28a&scoped=true&"
import script from "./SurveyQuestionList.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestionList.vue?vue&type=style&index=0&id=0204d28a&lang=scss&scoped=true&"
import style1 from "./SurveyQuestionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204d28a",
  null
  
)

export default component.exports